export default __webpack_public_path__ + "static/media/Save the Grandmother.dfe43481.png";